import { useContext } from 'react';
import { Grid, List, ListItem, Typography, ListItemText, Chip, FormControlLabel, Checkbox } from '@mui/material';
import { ticketDetailsContext } from '../../TicketDetailsContext';
import { DeleteIconButton, SimecUser } from 'components';
import { appUserContext } from 'helpers/services';
import { LocalizationIds } from 'helpers/Localizations';
import { useIntl } from 'react-intl';
import { MdCheck } from 'react-icons/md';


const MobileVersion = () => {
    const { formatMessage } = useIntl();

    const { currentUser } = useContext(appUserContext);
    const service = useContext(ticketDetailsContext);



    return (
        <List>
            {service.ticket.assigneeUserName && service.ticket.assigneeUserName !== '' &&
                <ListItem disableGutters divider >
                    <Grid container alignItems="center">
                        <Grid item xs>
                            <Typography variant="body2">
                                <b>{formatMessage({ id: LocalizationIds.Name })}:</b>&nbsp;
                            </Typography>
                            {service.ticket.assigneeUser}
                        </Grid>
                        <Grid item xs>
                            <Chip icon={<MdCheck />} label={formatMessage({ id: LocalizationIds.ReceiveNotifications })} />
                        </Grid>
                    </Grid>
                    <ListItemText secondary={formatMessage({ id: LocalizationIds.Assignee })} />
                </ListItem>
            }
            {service.ticket.reporterUserName && service.ticket.reporterUserName !== '' &&
                <ListItem disableGutters divider >
                    <Grid container alignItems="center">
                        <Grid item xs>
                            <Typography variant="body2">
                                <b>{formatMessage({ id: LocalizationIds.Name })}:</b>&nbsp;
                            </Typography>
                            {service.ticket.reporterUser}
                        </Grid>
                        <Grid item xs>
                            <Chip icon={<MdCheck />} label={formatMessage({ id: LocalizationIds.ReceiveNotifications })} />
                        </Grid>
                    </Grid>
                    <ListItemText secondary={formatMessage({ id: LocalizationIds.Reporter })} />
                </ListItem>
            }
            {service.ticketWatchers
                .map((watcher, index) =>
                    <ListItem disableGutters divider key={index}>
                        <Grid container alignItems="center">
                            <Grid item xs>
                                <Typography variant="body2">
                                    <b>{formatMessage({ id: LocalizationIds.Name })}:</b>&nbsp;
                                </Typography>
                                <SimecUser username={watcher.email} />
                            </Grid>
                            <Grid item xs>
                                {watcher.canUpdateNotificationsFlag === false && watcher.receiveNotifications === true &&
                                    <Chip icon={<MdCheck />} label={formatMessage({ id: LocalizationIds.ReceiveNotifications })} />
                                }
                                {watcher.canUpdateNotificationsFlag &&
                                    <FormControlLabel
                                        label={formatMessage({ id: LocalizationIds.ReceiveNotifications })}
                                        control={<Checkbox
                                            checked={watcher.receiveNotifications}
                                            onChange={async (e) => await service.updateWatcher({ ...watcher, receiveNotifications: e.target.checked })}
                                            color="secondary"
                                        />}
                                    />
                                }
                            </Grid>
                            {service.ticket.isReadOnly === false && currentUser.simecClaims.canWorkOnMyTickets === false &&
                                <Grid item>
                                    <DeleteIconButton onClick={async () => service.removeWatcher(watcher.email)} />
                                </Grid>
                            }
                        </Grid>
                    </ListItem>
                )}
        </List>
    )
}

export default MobileVersion;